exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".crop-devices-clickable[data-v-fd5607ce]{cursor:pointer}", "", {"version":3,"sources":["/home/ponce-dev-production/report/src/components/OrganizationHome/ManageField.vue"],"names":[],"mappings":"AACA,yCACE,cAAgB,CACjB","file":"ManageField.vue","sourcesContent":["\n.crop-devices-clickable[data-v-fd5607ce] {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fd5607ce","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OrganizationHome/ManageField.vue
// module id = 1535
// module chunks = 0